<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile" id="header-div">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="row center" :class="{'justify-content-between': !isScreenMobile}" style="width: 100%">
                    <AppOperationsFilterBar v-show="!isScreenMobile" ref="operationsFilterBar" :map-types="mapTypes"
                                            :comparing-operations="comparingOperations" :map-types-two="mapTypesTwo"
                                            @updateLoading="updateLoading" @selectedOrg="setSelectedOrg"
                                            @fields="updateFields" @selectedField="setSelectedField"
                                            @operations="updateOperations" @selectedOperation="setSelectedOperation"
                                            @updateSelectedMapType="setSelectedMapType"
                                            @updateCompareOperationTwo="setCompareOperationTwo"
                                            @updateSelectedMapTypeTwo="setSelectedMapTypeTwo"
                                            @exitCompare="exitCompare" @initTimeline="initTimeline"/>
                    <AppButton v-if="isScreenMobile" type="primary" class="mr-2"
                               @handleClick="openFilterDialog">
                        {{ $t('AppOperations.Filtrar') }}
                    </AppButton>
                    <div v-if="selectedOperation">
                        <Menu id="overlay_menu" ref="menu" appendTo="header-div" :model="menuItems" popup/>
                        <Button v-if="!comparingOperations" aria-controls="overlay_menu" aria-haspopup="true"
                                :label="$t('AppOperations.Gerenciar')" icon="pi pi-cog" @click="toggle"/>
                        <Button v-else :label="$t('AppOperations.Sair do modo comparação')" icon="pi pi-times"
                                @click="exitCompare(true)"/>
                    </div>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div v-if="!selectedOrg" class="row no-gutters text-center mx-3">
                    <h3 class="col-12 mt-5">
                        {{ $t('AppOperations.Selecione a organização para analisar suas operações') }}
                    </h3>
                </div>
                <div v-else>
                    <AppFieldsAsideMenu v-if="!isScreenMobile" ref="fieldAsideMenu" :selected-field="selectedField"
                                        :fields="fields" :loading="loading" class="fields-list"
                                        @selectField="setSelectedField"/>
                    <div :style="{marginLeft: isScreenMobile ? '0' : '110px'}">
                        <div v-if="!comparingOperations" class="agro-body operations"
                             :class="timelinePaneSize < 1 ? $t('AppOperations.panel-show') : $t('AppOperations.panel-hide')">
                            <splitpanes horizontal @resize="redrawTimeline($event[1].size)" class="default-theme"
                                        @splitter-click="togglePane">
                                <pane :size="100 - timelinePaneSize">
                                    <AppOperationsAnalyze class="operations-analyze" ref="operations_analyze"
                                                          :selected-field="selectedField" :field-center="fieldCenter"
                                                          :selected-operation="selectedOperation" :loading="loading"
                                                          :hasOperations="organizationHasOperations"
                                                          :selected-map-type="selectedMapType"
                                                          @setAvailableMapTypes="setAvailableMapTypes"
                                                          @clearAvailableMapTypes="clearAvailableMapTypes"/>
                                </pane>
                                <pane :size="timelinePaneSize">
                                    <div class="timeline-body">
                                        <AppTimeline ref="timeline" class="analyze-operations-timeline"
                                                     :items="operations" @handleSelect="handleSelect"/>
                                    </div>
                                </pane>
                            </splitpanes>
                        </div>
                        <div v-else>
                            <AppOperationsCompare class="operations-compare" :operation-one="selectedOperation"
                                                  :map-type-one="selectedMapType" :map-types-one="mapTypes"
                                                  :operation-two="compareOperationTwo" :map-types-two="mapTypesTwo"
                                                  :map-type-two="selectedMapTypeTwo" :selected-field="selectedField"
                                                  :field-center="fieldCenter"
                                                  @setAvailableMapTypesOne="setAvailableMapTypes"
                                                  @setAvailableMapTypesTwo="setAvailableMapTypesTwo"
                                                  @clearAvailableMapTypesOne="clearAvailableMapTypes"
                                                  @clearAvailableMapTypesTwo="clearAvailableMapTypesTwo"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Dialog :header="$t('AppOperations.Filtrar')" :visible.sync="showFilterDialog" :contentStyle="{width: '85vw', overflow: 'visible'}" modal>
            <AppOperationsFilterBar ref="operationsFilterBarDialog" :organization-has-operations="organizationHasOperations"
                                    :map-types="mapTypes" :map-types-two="mapTypesTwo" :mobile-view="true"
                                    :comparing-operations="comparingOperations" @selectedField="setSelectedField"
                                    @operations="updateOperations" @selectedOperation="setSelectedOperation"
                                    @updateSelectedMapType="setSelectedMapType"
                                    @updateCompareOperationTwo="setCompareOperationTwo"
                                    @updateSelectedMapTypeTwo="setSelectedMapTypeTwo"/>
        </Dialog>

        <Dialog :visible.sync="showCompareDialog" :style="{width: '400px'}" :header="$t('AppOperations.Comparar')"
                modal>
            <perfect-scrollbar id="container">
                <div v-for="operation in operations" :id="operation.name" class="operation-compare-item"
                     @click="handleClickCompareOperation(operation)">
                    {{ operation.display_name }}
                </div>
            </perfect-scrollbar>
        </Dialog>

        <Dialog :visible.sync="showOperationProcessingDialog" :style="{width: isScreenMobile ? '85vw' : '500px'}"
                :header="$t('AppOperations.Atenção')" modal>
            <div>
                {{ $t('AppOperations.Esta operação está em processamento') }}
            </div>
        </Dialog>

        <AppOperationExportRequestDialog v-if="selectedField && selectedOperation" :operation="selectedOperation"
                                         :field="selectedField" :show-dialog="showExportDialog" :mobile="isScreenMobile"
                                         @hideDialog="closeDialog" @requestExport="requestExport"/>
    </div>
</template>

<script>
import OperationsService from "@/services/OperationsService";

import AppTimeline from "./AppOperationsTimeline";
import AppButton from "@/components/common/AppButton.vue";
import AppFieldsAsideMenu from "./AppFieldsAsideMenu.vue";
import AppOperationsAnalyze from "./AppOperationsAnalyze";
import AppOperationsCompare from "./AppOperationsCompare";
import AppOperationsFilterBar from "./AppOperationsFilterBar.vue";
import AppOperationExportRequestDialog from "../file-export/AppOperationExportRequestDialog.vue";

import 'splitpanes/dist/splitpanes.css'
import {Pane, Splitpanes} from 'splitpanes'

import Menu from "primevue/menu";
import Badge from "primevue/badge";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Dropdown from 'primevue/dropdown';

export default {
    mounted() {
        this.operationsService = new OperationsService();

        if (!this.isScreenMobile) {
            this.menuItems.push({
                    label: this.$t('AppOperations.Comparar'),
                    icon: 'pi pi-map',
                    command: () => this.compareOperations()
                })
        }
    },
    data() {
        return {
            loading: false,
            operations: [],
            selectedOrg: null,
            fields: [],
            selectedField: null,
            selectedOperation: null,
            selectedMapType: null,
            mapTypes: [],
            mapTypesTwo: [],
            comparingOperations: false,
            compareOperationTwo: null,
            selectedMapTypeTwo: null,
            timeline: null,
            fieldCenter: {lat: -25.407688, lng: -49.253990},
            timelinePaneSize: 0,
            showCompareDialog: false,
            showExportDialog: false,
            loadingTilesInfo: false,
            showFilterDialog: false,
            showOperationProcessingDialog: false,
            menuItems: [
                {
                    label: this.$t('AppOperations.Gerar relatório'),
                    icon: 'pi pi-file-pdf',
                    command: () => this.openReportDialog()
                },
                {
                    label: this.$t('AppOperations.Exportar dados da operação'),
                    icon: 'pi pi-external-link',
                    command: () => this.openExportDialog()
                }
            ]
        }
    },
    methods: {
        updateLoading(loading) {
            this.loading = loading;
        },
        handleSelect(event) {
            this.selectOperationFromTimeline(event.items[0])
        },
        toggle(event) {
            this.$refs.menu.toggle(event);
        },
        compareOperations() {
            this.showCompareDialog = true;
        },
        openReportDialog() {
            this.$refs.operations_analyze.openReportDialog();
        },
        async openExportDialog() {
            if (await this.isOperationBeingProcessed()) {
                return;
            }

            this.showExportDialog = true;
        },
        async isOperationBeingProcessed() {
            let response;
            try {
                response = await this.operationsService.getOperationStatus(this.selectedOperation.id)
            } catch (error) {
                this.showOperationProcessingDialog = true
                return true;
            }

            let processing = response.operation_process !== 'NONE';
            if (processing) {
                this.showOperationProcessingDialog = true
            }

            return processing;
        },
        requestExport(fileName) {
            this.operationsService.requestExportFile(this.selectedOperation.id, fileName)
                .then(() => {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$t('AppOperations.Requisição realizada com sucesso'),
                        life: 5000
                    });
                    this.closeDialog()
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppOperations.Houve um erro ao realizar a requisição para exportação dos dados desta operação'),
                        life: 5000
                    });
                })
        },
        closeDialog() {
            this.showCompareDialog = false;
            this.showExportDialog = false;
            this.showOperationProcessingDialog = false;
        },
        openFilterDialog() {
            this.showFilterDialog = true;
            setTimeout(() => {
                this.$refs.operationsFilterBarDialog?.setSelectedMapType(this.selectedMapType);
                this.$refs.operationsFilterBarDialog?.setCompareOperationTwo(this.compareOperationTwo);
                this.$refs.operationsFilterBarDialog?.setSelectedMapTypeTwo(this.selectedMapTypeTwo);
            }, 50);
        },
        handleClickCompareOperation(operationToCompare) {
            this.clearQuery();
            this.compareOperationTwo = operationToCompare;
            this.showCompareDialog = false;
            this.comparingOperations = true;
        },
        exitCompare(btnClick = false) {
            if (!this.comparingOperations) {
                return;
            }

            if (btnClick) {
                this.$refs.operationsFilterBar.updateQuery();
                setTimeout(() => this.$refs.operations_analyze?.getStatistics(), 50)
            }

            this.comparingOperations = false
            this.compareOperationTwo = null;
            this.selectedMapTypeTwo = null;
        },
        clearQuery() {
            this.$router.replace({...this.$router.currentRoute, query: {}});
        },
        selectOperationFromTimeline(itemId) {
            let operation = this.operations.find(obj => obj.id === itemId)
            if (operation) {
                this.selectedOperation = operation;
                this.$refs.operationsFilterBar.selectOperationFromTimeline(operation);
            }
        },
        redrawTimeline(panelSize) {
            this.timelinePaneSize = panelSize
            this.timeline.redraw();
        },
        togglePane() {
            if (this.timelinePaneSize > 1) {
                this.timelinePaneSize = 0
                this.timeline.zoomOut(1);
                return
            }

            this.timelinePaneSize = 20
            this.timeline.zoomIn(1);
        },
        setSelectedOrg(selectedOrg) {
            this.selectedOrg = selectedOrg;
        },
        updateFields(fields) {
            this.fields = fields;
        },
        setSelectedField(selectedField, fromAsideMenu) {
            this.selectedField = selectedField;
            if (fromAsideMenu) {
                this.exitCompare();
                this.$refs.operationsFilterBar.onFieldSelection(this.selectedField, true);
                return;
            }

            setTimeout(() => this.$refs.fieldAsideMenu?.focusOnSelectedField(selectedField), 2000);
        },
        updateOperations(operations) {
            this.operations = operations;
        },
        setSelectedOperation(selectedOperation) {
            this.selectedOperation = selectedOperation;
            if (this.selectedOperation) {
                this.onOperationSelected();
            }
        },
        async onOperationSelected() {
            await this.sleep(500);

            this.timeline.unselectAll();
            this.timeline.clearHover(this.selectedOperation);
            this.timeline.setSelection(this.selectedOperation.id);
            this.timeline.setFocusItem(this.selectedOperation);

            if (this.comparingOperations) {
                return;
            }

            if (this.showFilterDialog) {
                this.$refs.operationsFilterBarDialog.updateQuery();
                return;
            }

            this.$refs.operationsFilterBar.updateQuery();
        },
        async initTimeline() {
            await this.sleep(1);
            this.timeline = this.$refs.timeline;
            this.timeline.redraw();
            this.timeline.refresh();
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        setSelectedMapType(selectedMapType) {
            this.selectedMapType = selectedMapType
        },
        setCompareOperationTwo(compareOperationTwo) {
            this.compareOperationTwo = compareOperationTwo
        },
        setSelectedMapTypeTwo(selectedMapTypeTwo) {
            this.selectedMapTypeTwo = selectedMapTypeTwo
        },
        setAvailableMapTypes(availableMapTypes) {
            this.mapTypes = availableMapTypes;
            this.selectedMapType = this.mapTypes[0];
        },
        clearAvailableMapTypes() {
            this.mapTypes = [];
            this.selectedMapType = null;
        },
        setAvailableMapTypesTwo(availableMapTypesTwo) {
            this.mapTypesTwo = availableMapTypesTwo;
            this.selectedMapTypeTwo = this.mapTypesTwo[0];
        },
        clearAvailableMapTypesTwo() {
            this.mapTypesTwo = [];
            this.selectedMapTypeTwo = null;
        }
    },
    components: {
        AppButton,
        Badge,
        Pane,
        Menu,
        Dialog,
        Dropdown,
        Splitpanes,
        Button,
        AppOperationsFilterBar,
        AppFieldsAsideMenu,
        AppTimeline,
        AppOperationsAnalyze,
        AppOperationsCompare,
        AppOperationExportRequestDialog
    },
    watch: {
        selectedMapType: function () {
            if (this.isScreenMobile) {
                this.$refs.operationsFilterBarDialog?.setSelectedMapType(this.selectedMapType);
                return;
            }
            this.$refs.operationsFilterBar?.setSelectedMapType(this.selectedMapType);
        },
        compareOperationTwo: function () {
            if (this.isScreenMobile) {
                this.$refs.operationsFilterBarDialog?.setCompareOperationTwo(this.compareOperationTwo);
                return;
            }
            this.$refs.operationsFilterBar?.setCompareOperationTwo(this.compareOperationTwo);
        },
        selectedMapTypeTwo: function () {
            if (this.isScreenMobile) {
                this.$refs.operationsFilterBarDialog?.setSelectedMapTypeTwo(this.selectedMapTypeTwo);
                return;
            }
            this.$refs.operationsFilterBar?.setSelectedMapTypeTwo(this.selectedMapTypeTwo);
        }
    },
    computed: {
        organizationHasOperations: function () {
            return this.operations.length > 0;
        },
        isScreenMobile: function () {
            return window.screen.width <= 1024;
        }
    }
}
</script>

<style scoped lang="scss">
.splitpanes.default-theme .splitpanes__pane {
    background-color: #fff;
}

.agro-body {
    position: relative;
    height: calc(100vh - 81px) !important;
}

.operations-compare {
    height: calc(100vh - 81px) !important;
}

.operations-analyze {
    height: 100% !important;
}

.timeline-body {
    width: 100%;
    height: 100%;
    z-index: 1;
}

.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.operation-compare-item {
    border-bottom: 1px solid #e0e0e0;
    height: 50px;
    display: flex;
    align-items: center;
    color: #393939;
    padding-left: 10px;
    cursor: pointer;
}

.fields-list {
    max-height: calc(100vh - 80px);
    position: absolute;
    z-index: 10;
    top: 80px;
    left: 140px;
    width: 110px;
    border-left: 1px solid #9e9b9b;
    border-right: 1px solid rgba(158, 155, 155, 0.2);
}

.fields-list:hover {
    width: 300px;
}

@media (max-width: 1024px) {
    .fields-list {
        top: 110px;
        left: 0;
        height: 100vh;
    }
}
</style>
